export enum AdditionSourceType {
  OMS = "OMS",
  FULFILLMENT = "FULFILLMENT",
  DISPATCH = "DISPATCH"
}
